export const useStyles = () => ({
  formPageContainer: {
    paddingBottom: '30px',
    paddingLeft: '50px',
  },
  componentsContainer: {
    margin: '10px 0 40px',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  messageParagraphs: {
    marginLeft: '20px',
    marginTop: '20px',
  },
  backToStandard: {
    marginLeft: '20px',
    cursor: 'pointer',
    fontWeight: 'normal',
  },
  pageLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  }
});
